import { css } from '@emotion/react'

import variables from 'styles/variables'
import { cdnImageUrl } from 'lib/cdn'
import { defaultTheme } from 'styles/theme'
import { fontFace } from 'styles/font'
import { zIndex } from 'styles'

export const baseStyles = css`
  ${fontFace}

  body {
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  ${variables}

  * {
    font-family:
      'PxGroteskRegular', 'PxGrotesk Fallback', 'Helvetica Neue', Arial,
      sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* react-inner-image-zoom */
  .iiz {
    width: 100% !important;
    height: 100% !important;
    cursor:
      url(${cdnImageUrl({ imageName: 'zoomInCursorSVG' })}),
      url(${cdnImageUrl({ imageName: 'zoomInCursor' })}), zoom-in !important;
  }

  .iiz__img {
    position: absolute !important;
    left: 50% !important;
    transform: translate(-50%, 0) !important;
    height: 100% !important;
    width: auto !important;
  }

  .iiz__zoom-img {
    width: 480px !important;
    height: auto !important;
  }

  @media screen and (min-width: ${defaultTheme.breakpoints.med}) {
    .iiz__zoom-img {
      width: 768px !important;
    }
  }

  @media screen and (min-width: ${defaultTheme.breakpoints.lg}) {
    .iiz__zoom-img {
      width: auto !important;
    }
  }

  .iiz__zoom-img {
    cursor:
      url(${cdnImageUrl({ imageName: 'zoomOutCursorSVG' })}),
      url(${cdnImageUrl({ imageName: 'zoomOutCursor' })}), zoom-out !important;
  }

  .iiz__hint {
    display: none !important;
  }

  .iiz__close {
    background: transparent !important;
    width: 49px !important;
    height: 56px !important;
    position: absolute !important;
    top: calc(100% - 56px) !important;
    right: 0 !important;
    z-index: ${zIndex.modal} !important;
  }

  .iiz__close::before {
    background-image: url(${cdnImageUrl({
      imageName: 'zoomOutCursorMobile',
    })}) !important;
    background-size: auto !important;
    transform: none !important;
    width: 25px !important;
    height: 24px !important;
  }

  @media screen and (min-width: ${defaultTheme.breakpoints.med}) {
    .iiz__close {
      width: 57px !important;
    }
  }

  /**** COOKIEBOT OVERRIDES *****/

  /* Unify text across all the dialog */
  #CybotCookiebotDialog * {
    font-family:
      'PxGroteskRegular', 'PxGrotesk Fallback', 'Helvetica Neue', Arial,
      sans-serif !important;
    font-size: 18px !important;
    line-height: 28px !important;
    letter-spacing: 2px !important;
  }

  /* Remove border radius on dialog details view */
  div#CybotCookiebotDialogContentWrapper {
    border-radius: 0;
  }

  // In order,
  // - Diaglog details view tabs,
  // - allow/deny buttons,
  // - the consent switch toggles,
  // - the slide up panel title
  ul#CybotCookiebotDialogNavList,
  #CybotCookiebotDialogFooter #CybotCookiebotDialogBodyButtonsWrapper *,
  #CybotCookiebotDialogBodyFieldsetInnerContainer
    label.CybotCookiebotDialogBodyLevelButtonLabel,
  #CybotCookiebotDialogBodyContent h2#CybotCookiebotDialogBodyContentTitle {
    text-transform: uppercase;
  }

  /* Updates all buttons */
  #CybotCookiebotDialogFooter #CybotCookiebotDialogBodyButtonsWrapper * {
    border-radius: 0;
  }

  /* Updates Allow All Button */
  #CybotCookiebotDialogFooter
    button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll {
    border: 1px solid rgb(0, 0, 0);
    background-color: rgb(0, 0, 0);
    color: rgb(255, 255, 255);
  }
  #CybotCookiebotDialogFooter
    button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll:hover {
    background: rgb(255, 255, 255);
    color: rgb(0, 0, 0);
    box-shadow: rgb(0 0 0) -2px -2px 0px inset;
    border: 1px solid rgb(0, 0, 0);
  }
  #CybotCookiebotDialogFooter
    button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll:active {
    background: rgb(235, 235, 239);
    color: rgb(0, 0, 0);
    box-shadow: rgb(0 0 0) 2px 2px 0px inset;
    border: 1px solid rgb(0, 0, 0);
  }

  /* Updates Decline & Selection button */
  #CybotCookiebotDialogFooter button#CybotCookiebotDialogBodyButtonDecline,
  #CybotCookiebotDialogFooter
    button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection {
    background: rgb(255, 255, 255);
    color: rgb(0, 0, 0);
    box-shadow: rgb(0 0 0) -2px -2px 0px inset;
    border: 1px solid rgb(0, 0, 0);
  }
  #CybotCookiebotDialogFooter
    button#CybotCookiebotDialogBodyButtonDecline:hover,
  #CybotCookiebotDialogFooter
    button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection:hover {
    background-color: rgb(0, 0, 0);
    color: rgb(255, 255, 255);
  }
  #CybotCookiebotDialogFooter
    button#CybotCookiebotDialogBodyButtonDecline:active,
  #CybotCookiebotDialogFooter
    button#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection:active {
    background: rgb(235, 235, 239);
    color: rgb(0, 0, 0);
    box-shadow: rgb(0 0 0) 2px 2px 0px inset;
    border: 1px solid rgb(0, 0, 0);
  }

  /* Removes Header overall - we may not want this, but it makes slide up mode much cleaner */
  div#CybotCookiebotDialogHeader {
    display: none;
  }

  /* Branding on the banner */
  a#CybotCookiebotDialogPoweredbyCybot,
  div#CybotCookiebotDialogPoweredByText,
  img#CybotCookiebotDialogPoweredbyImage {
    display: none;
  }

  /* Branding on the widget */
  #CookiebotWidget .CookiebotWidget-body .CookiebotWidget-main-logo {
    display: none;
  }
`
